import { Chip, Tooltip } from "@mui/material";
import React from "react";
import { ListLinkValue } from "source/components/framework/List/ListLinkValue";
import { Base } from "ui/Scripts/source/framework/base";

interface ITaskStateListChipProps {
    icon?: React.ReactElement;
    code: string;
    color: string;
    inactive?: boolean;
    fullWidth?: boolean;
    onClick?: () => void;
}

export const TaskStateListChip = (props: ITaskStateListChipProps) => {
    const textColor = Base.invertColor(props.color, true);

    return (
        <Tooltip title={props.code}>
            <Chip
                icon={props.icon}
                label={props.onClick
                    ? <ListLinkValue onClick={props.onClick} inactive={props.inactive} color={textColor}>{props.code}</ListLinkValue>
                    : props.code}
                size="small"
                sx={{ backgroundColor: props.color, color: textColor, width: props.fullWidth ? "100%" : null }}
            />
        </Tooltip>
    );
};
